import React, { useEffect, useState } from 'react';
import { Grid, TextField, Button, IconButton, Typography, Box, CircularProgress, FormControlLabel, Checkbox } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import PN from "persian-number";
import axios from './../../axios/api';

import { DatePicker } from '@react-shamsi/datepicker';
import "./../Advertising/styleDatePicker.css"
import toast from 'react-hot-toast';
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const FormPlans = ({ isEdit = false, IdEdit, handleCloseModal, refreshData, DataEdit }) => {
    const [Title, setTitle] = useState('');
    const [Desc, setDesc] = useState('');
    const [Price, setPrice] = useState('');
    const [Discount, setDiscount] = useState('');
    const [maxDate, setMaxDate] = useState(new Date());
    const [Day, setDay] = useState('')
    const [LoadingButton, setLoadingButton] = useState(false);
    const [errors, setErrors] = useState({ title: '', days: '', price: '', discount: '', message: '' });
    const [IsActive, setIsActive] = useState(false);

    function stringToBool(str) {
        return str.toLowerCase() === 'true';
    }


    useEffect(() => {
        if (isEdit) {
            console.log("DDDDDD" + JSON.stringify(DataEdit));
            setTitle(DataEdit?.title);
            setDay(DataEdit?.days);
            setPrice(DataEdit?.price);
            setDiscount(DataEdit?.discount);
            if (DataEdit?.is_active) {
                setIsActive(stringToBool(DataEdit?.is_active));
            }
            setDesc(DataEdit?.message);

        }
    }, [isEdit])


    const reseteState = () => {
        setTitle('');
        setDesc('');
        setPrice('');
        setDiscount('');
        setDay(null);
        setIsActive(false)
    }

    const handleTitleChange = (event) => {
        setTitle(event.target.value);
        if (errors.title) {
            setErrors((prevErrors) => ({ ...prevErrors, title: '' }));
        }
    };
    const handleDescChange = (event) => {
        setDesc(event.target.value);
        if (errors.message) {
            setErrors((prevErrors) => ({ ...prevErrors, message: '' }));
        }
    };
    const handlePriceChange = (event) => {
        const value = event.target.value.replace(/,/g, ''); // Remove existing commas
        if (!isNaN(Number(value))) { // Ensure the value is a number
            setPrice(value);
        }
        if (errors.price) {
            setErrors((prevErrors) => ({ ...prevErrors, price: '' }));
        }
    };


    const handleDayChange = (event) => {
        const value = event.target.value.replace(/,/g, ''); // Remove existing commas
        if (!isNaN(Number(value))) { // Ensure the value is a number
            setDay(value);
        }
        if (errors.days) {
            setErrors((prevErrors) => ({ ...prevErrors, days: '' }));
        }
    };

    const formatNumber = (value) => {
        const formattedValue = new Intl.NumberFormat('en-US').format(value);
        return formattedValue;
    };

    const formatPercentNumber = (number) => {
        return number !== '' ? `%${number}` : '';
    };

    const handleDiscountChange = (e) => {
        let value = e.target.value;

        // Remove any non-numeric characters and percentage sign
        value = value.replace(/[^0-9]/g, '');

        // Ensure value is within the range 0-99
        if (value !== '') {
            value = Math.min(99, Math.max(0, Number(value)));
        }
        if (errors.discount) {
            setErrors((prevErrors) => ({ ...prevErrors, discount: '' }));
        }
        setDiscount(value);
    };



    const UpdatePlan = async () => {
        try {
            setLoadingButton(true);
            // Send the base64 string using axios


            const res = await axios.put(`/admin/plan/update/${IdEdit}`, {
                title: Title,
                days: parseInt(Day),
                price: parseInt(Price),
                discount: Discount,
                message: Desc,
                is_active: typeof IsActive === "boolean" ? (IsActive) ? "1" : "0" : stringToBool(IsActive) ? "1" : "0",
            });

            toast.success(res.data?.message);
            refreshData();
            reseteState();
            handleCloseModal();
        } catch (error) {
            toast.error(error.response?.data?.message || 'An error occurred');

            if (error.response?.status === 422) {
                setErrors({
                    title: error.response.data.data.title ? error.response.data.data.title[0] : '',
                    days: error.response.data.data.days ? error.response.data.data.days[0] : '',
                    message: error.response.data.data.message ? error.response.data.data.message[0] : '',
                    price: error.response.data.data.price ? error.response.data.data.price[0] : '',
                    discount: error.response.data.data.discount ? error.response.data.data.discount[0] : '',
                });
            }
        } finally {
            setLoadingButton(false);
        }
    };



    const sendPlan = async () => {
        try {
            setLoadingButton(true);

            // Send the base64 string using axios
            const res = await axios.post('/admin/plan/store', {
                title: Title,
                days: parseInt(Day),
                price: parseInt(Price),
                discount: Discount,
                is_active: typeof IsActive === "boolean" ? (IsActive) ? "1" : "0" : stringToBool(IsActive) ? "1" : "0",

                message: Desc
            });

            toast.success(res.data?.message);
            reseteState();

        } catch (error) {
            toast.error(error.response?.data?.message || 'An error occurred');
            if (error.response?.status === 422) {
                setErrors({
                    title: error.response.data.data.title ? error.response.data.data.title[0] : '',
                    days: error.response.data.data.days ? error.response.data.data.days[0] : '',
                    message: error.response.data.data.message ? error.response.data.data.message[0] : '',
                    price: error.response.data.data.price ? error.response.data.data.price[0] : '',
                    discount: error.response.data.data.discount ? error.response.data.data.discount[0] : '',
                });
            }
        } finally {
            setLoadingButton(false);
        }
    };
    const handleChangeActive = (event) => {
        setIsActive(event.target.checked);
    };

    return (
        <div dir="rtl">
            <Grid container spacing={2}>

                <Grid item lg={6} md={6} sm={12}>
                    <TextField
                        id="title"
                        label="عنوان پلن"
                        type="text"
                        placeholder='عنوان پلن ...'
                        variant="outlined"
                        fullWidth
                        value={Title}
                        onChange={handleTitleChange}
                        error={Boolean(errors.title)}
                        helperText={errors.title}
                    />
                </Grid>

                <Grid item lg={6} md={6} sm={12}>
                    <TextField
                        id="Day"
                        label="تعداد روز"
                        type="text"
                        placeholder='مثلا 10 روز'
                        variant="outlined"
                        fullWidth
                        value={formatNumber(Day)}
                        onChange={handleDayChange}
                        error={Boolean(errors.days)}
                        helperText={errors.days}
                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} // Ensure numeric keyboard on mobile
                    />
                </Grid>

                <Grid item lg={6} md={6} sm={12}>
                    <TextField
                        id="price"
                        label="قیمت پلن"
                        type="text"
                        placeholder='قیمت پلن ...'
                        variant="outlined"
                        fullWidth
                        value={formatNumber(Price)}
                        onChange={handlePriceChange}
                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} // Ensure numeric keyboard on mobile

                        error={Boolean(errors.price)}
                        helperText={errors.price ? errors.price : Price && <Typography variant='caption' color="gray">{PN.convert(Price)} تومان </Typography>}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={12}>

                    <TextField
                        id="Discount"
                        label="درصد تخفیف پلن"
                        type="text"
                        placeholder='تخفیف پلن ...'
                        variant="outlined"
                        fullWidth
                        value={formatPercentNumber(Discount)}
                        onChange={handleDiscountChange}
                        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                        helperText={errors.discount ? errors.discount : Price && Discount && <Typography variant='caption' color="gray">مبلغ کل : {formatNumber((Price - (Price * (Discount / 100)))) + " (معادل " + PN.convert((Price - (Price * (Discount / 100)))) + " تومان)"}  </Typography>}
                        error={Boolean(errors.discount)}
                    />


                </Grid>
                {/* <Grid item lg={12} md={12} sm={12} sx={{ zIndex: 9999999999, width: '100%' }} >
                    <Typography variant='body2'>تاریخ اعتبار</Typography>
                    <DatePicker
                        placeholder='تاریخ اعتبار را وارد کنید'
                        style={{ zIndex: 99999, fontFamily: 'IranSans', width: '100%', padding: 15 }}
                        autoUpdate
                        date={maxDate}
                        onChange={setMaxDate}

                    />
                </Grid> */}
                <Grid item lg={12} md={12} sm={12}>

                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={IsActive}
                                onChange={handleChangeActive}
                                inputProps={{ 'aria-label': 'controlled' }}
                            />
                        }
                        label={<Typography color={IsActive ? "green" : "black"} variant="h6">وضعیت پلن: {IsActive ? "(فعال)" : "(غیرفعال)"}</Typography>}
                    />
                </Grid>
                <Grid item lg={12} md={12} sm={12}>
                    <TextField
                        id="outlined-multiline-static"
                        label="توضیحات پلن"
                        placeholder='توضیحات پلن.....'
                        multiline
                        rows={4}
                        variant="outlined"
                        fullWidth
                        sx={{
                            mb: 2,
                        }}
                        value={Desc}
                        onChange={handleDescChange}
                        error={Boolean(errors.message)}
                        helperText={errors.message}
                    />
                </Grid>

                <Grid item lg={12} md={12} sm={12}>
                    {isEdit ?
                        <Button
                            color="secondary"
                            fullWidth
                            variant="contained"
                            size="large"
                            onClick={UpdatePlan}
                            disabled={LoadingButton}
                        >
                            {LoadingButton && <CircularProgress size={24} color="inherit" />}

                            <Typography color="white">ویرایش پلن </Typography>
                        </Button>
                        :
                        <Button
                            color="secondary"
                            fullWidth
                            variant="contained"
                            onClick={sendPlan}
                            disabled={LoadingButton}
                            size="large">
                            {LoadingButton && <CircularProgress size={24} color="inherit" />}

                            <Typography color="white">ثبت پلن جدید</Typography>
                        </Button>
                    }
                </Grid>
            </Grid>
        </div>
    );
};

export default FormPlans;
